import React from 'react'
import { Descriptions, Table } from 'antd'
import TablePage from '../../../../../../components/pages/TablePage'
import moment from 'moment'

// API list batal PLP mengembalikan bentuk flat / { header, kemasan, kontainer }
const getKemasan = (row) => row?.kemasan || row?.header?.kemasan || [];
const getKontainer = (row) => row?.kontainer || row?.header?.kontainer || [];
const pick = (row, key) => row?.[key] ?? row?.header?.[key];

const Detail = ({ data }) => {
    const kemasan = getKemasan(data);
    const kontainer = getKontainer(data);
    return (
        <div style={{ padding: 16 }}>
            <Descriptions size="small" bordered column={4}>
                <Descriptions.Item label="Ref Number">{pick(data, 'refNumber') || '-'}</Descriptions.Item>
                <Descriptions.Item label="No PLP">{pick(data, 'nomorPlp') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl PLP">{pick(data, 'tanggalPlp') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl Dibuat">{(data?.createdAt && moment(data.createdAt).format("DD-MMM-YYYY")) || '-'}</Descriptions.Item>
                <Descriptions.Item label="No Surat">{pick(data, 'nomorSurat') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl Surat">{pick(data, 'tanggalSurat') || '-'}</Descriptions.Item>
                <Descriptions.Item label="No BC 1.1">{pick(data, 'nomorBc11') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl BC 1.1">{pick(data, 'tanggalBc11') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Kode Kantor">{pick(data, 'kodeKantor') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Kode TPS">{pick(data, 'kodeTps') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tipe Data">{pick(data, 'tipeData') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Pemohon">{pick(data, 'namaPemohon') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Alasan" span={4}>{pick(data, 'alasan') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Kemasan" span={4}>
                    <Table
                        size="small"
                        pagination={false}
                        rowKey={(_, i) => i}
                        dataSource={kemasan || []}
                        columns={[
                            { title: 'Jenis Kemasan', dataIndex: 'jenisKemasan', key: 'jenisKemasan' },
                            { title: 'Jumlah Kemasan', dataIndex: 'jumlahKemasan', key: 'jumlahKemasan' },
                            { title: 'Nomor BL/AWB', dataIndex: 'nomorBlAwb', key: 'nomorBlAwb' },
                            { title: 'Tanggal BL/AWB', dataIndex: 'tanggalBlAwb', key: 'tanggalBlAwb' },
                        ]}
                    />
                </Descriptions.Item>
                <Descriptions.Item label="Kontainer" span={4}>
                    <Table
                        size="small"
                        pagination={false}
                        rowKey={(_, i) => i}
                        dataSource={(kontainer || []).filter((k) => k.nomorKontainer || k.ukuranKontainer)}
                        columns={[
                            { title: 'Nomor Kontainer', dataIndex: 'nomorKontainer', key: 'nomorKontainer' },
                            { title: 'Ukuran Kontainer', dataIndex: 'ukuranKontainer', key: 'ukuranKontainer' },
                        ]}
                    />
                </Descriptions.Item>
                <Descriptions.Item label="Respons" span={4}>{data?.response?.detail || data?.response?.result || '-'}</Descriptions.Item>
            </Descriptions>
        </div>
    );
};
export default () => { // eslint-disable-line
    const columns = [
        {
            selector: (row) => row?.refNumber || row?.header?.refNumber || '-',
            name: "Ref Number",
            id: 'refNumber'
        },
        {
            selector: (row) => row?.nomorPlp || row?.header?.nomorPlp || '-',
            name: "No PLP",
            id: 'nomorPlp'
        },
        {
            selector: (row) => row?.nomorSurat || row?.header?.nomorSurat || '-',
            name: "No Surat",
            id: 'nomorSurat'
        },
        {
            selector: (row) => row?.namaPemohon || row?.header?.namaPemohon || '-',
            name: "Nama Pemohon",
            id: 'namaPemohon'
        },
        {
            selector: (row) => getKemasan(row).reduce((sum, k) => sum + (Number(k.jumlahKemasan) || 0), 0) || '-',
            name: "Jml Kemas",
            id: 'jml_kemas'
        },
    ]
    return (
        <TablePage
            title={"Batal PLP"}
            url="api/v1/cancel_plp"
            actionPosition={'right'}
            createPath="/tps/plp/pembatalan/form"
            columns={columns}
            ExpandComponent={Detail}
        />
    )
}
